import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

export type AlertSeverity = 'success' | 'error' | 'info' | 'warn';

const TONE: Record<AlertSeverity, string> = {
  success:
    'border-l-4 border-success bg-success/10 text-success-fg outline-success/30',
  error:
    'border-l-4 border-danger bg-danger/10 text-danger-fg outline-danger/30',
  info: 'border-l-4 border-info bg-info/10 text-info-fg outline-info/30',
  warn: 'border-l-4 border-warning bg-warning/10 text-warning-fg outline-warning/30',
};

/** Inline form feedback. Replaces the p-message wrapper; same seam, same inputs. */
@Component({
  // `display: block` on the host: an Angular component element is inline by default,
  // and Tailwind's space-y-* sets margin-top, which does nothing on an inline box. As
  // an inline host this rendered with no vertical gap at all between siblings.
  host: { class: 'block' },
  selector: 'app-alert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="classes()" role="alert">{{ message() }}<ng-content /></div>
  `,
})
export class AlertComponent {
  readonly severity = input<AlertSeverity>('info');
  readonly message = input<string>('');

  protected readonly classes = computed(
    () =>
      'w-full rounded-md px-3 py-2 text-sm outline outline-offset-0 ' +
      TONE[this.severity()],
  );
}
